module.exports = __webpack_public_path__ + "static/media/img25.7a937871.jpg";